<div class="game-container" #gameContainer (mousedown)="handleInput()">
  <canvas #gameCanvas></canvas>
  <div class="ui-layer">
    @if (gameState() === 'idle') {
      <div class="start-message">{{ startText() }}</div>
    }
    <div class="tutorial-message" [class.visible]="tutorialVisible()">{{ tutorialText() }}</div>
    @if (gameState() === 'over') {
      <div class="game-over">
        <p>{{ gameOverText() }}</p>
      </div>
    }
  </div>
</div>
<div class="bottom-bar">
  <div class="hearts-container">
    @for (heart of hearts(); track $index) {
      <svg viewBox="0 0 11 11" width="16" height="16" class="heart">
        <rect x="2" y="2" width="2" height="1" />
        <rect x="7" y="2" width="2" height="1" />
        <rect x="1" y="3" width="9" height="3" />
        <rect x="2" y="6" width="7" height="1" />
        <rect x="3" y="7" width="5" height="1" />
        <rect x="4" y="8" width="3" height="1" />
        <rect x="5" y="9" width="1" height="1" />
      </svg>
    }
  </div>
  <div class="score-display" [style.visibility]="gameState() === 'idle' ? 'hidden' : 'visible'">
    {{ scoreText() }} {{ displayScore() }}
  </div>
</div>
